export enum EnumTipoDocumentoIdentidad {
  NIF = 1,
  Pasaporte,
  NIE,
  NIVA,
  Otros
}
